import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import { Label } from './label';
import { Button } from './button';
import { composeValidators, required, validatePassword } from '../../helpers/form-validations';
import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import PasswordStrengthMeter from '../login/PasswordStrengthMeter';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword } from '../../utils/util';
import { loaderSet } from '../../context/actions/loaderAction';
import { alertDanger, alertSuccess } from '../../context/actions/toastAction';

const ResetPasswordDialog = ({ onClose }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [oldPassword,setOldPassword]=useState("")
  const [newPassword,setNewPassword]=useState("")
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const userInfo=useSelector(state=>state.user)
  const dispatch=useDispatch()
  const onSubmit = async (values) => {
    dispatch(loaderSet(true))
    console.log("Reset Password Values:", values);

    const payload={
      email:userInfo && userInfo?.email,
      oldPassword:values.oldPassword,
      newPassword:values.newPassword
    }
    try {
      const response=await changePassword(payload)
      if(response.code===200){
        console.log("response handle submit change password",response)
        dispatch(alertSuccess("Successfully Changed Password"))
        onClose(); // Close dialog after submission
        dispatch(loaderSet(false))
        return 
      }
      if(response.code===400){
        dispatch(alertDanger("Incorrect old Password"))
        // onClose(); // Close dialog after submission
        dispatch(loaderSet(false))
      }
    } catch (error) {
      dispatch(loaderSet(false))
      dispatch(alertDanger("Change Password After Some Time"))
      console.log("response handle submit change password",error)
    }
    
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-md w-[90%] max-w-lg shadow-lg relative">
      <h2 className="text-lg font-semibold mb-4">Reset Password</h2>
  <button 
    type='button' 
    onClick={onClose} 
    className="absolute top-7 right-10 font-bold text-2xl text-red-600"
  >
   X
  </button>
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="flex flex-col">
              <Field
  id="oldPassword"
  name="oldPassword"
  type={showPassword ? 'text' : 'password'}
  placeholder="*************"
  validate={composeValidators(required)}
  render={({ input, meta }) => (
    <div className="relative grid gap-2">
      <div className="flex items-center">
        <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="password">Old Password</Label>
      </div>
      <input
        {...input}
        type={showPassword ? 'text' : 'password'}
        value={oldPassword}
        onChange={(e) => {
          input.onChange(e); // Update form state
          setOldPassword(e.target.value); // Also update password state
        }}
        placeholder="*************"
       className="bg-white pl-3 focus:outline-none h-9 w-full rounded-md text-base border border-[#3a5dd1] border-1  manrope-fontCss"
      />
      {meta.touched && meta.error && (
        <p className="text-red-500 text-sm text-left">&nbsp;{meta.error}</p>
      )}
      <div
        className="absolute h-15 top-11 -right-1 flex items-center px-4 cursor-pointer"
        onClick={togglePasswordVisibility}
      >
        {showPassword ? (
          <EyeNoneIcon className="h-5 w-5 text-black" />
        ) : (
          <EyeOpenIcon className="h-5 w-5 text-black" />
        )}
      </div>
    </div>
  )}
/>
              </div>

              <div className="flex flex-col">
              <Field
  id="newPassword"
  name="newPassword"
  type={showPassword ? 'text' : 'password'}
  placeholder="*************"
  validate={composeValidators(required,validatePassword)}
  render={({ input, meta }) => (
    <div className="relative grid gap-2">
      <div className="flex items-center">
        <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="password">New Password</Label>
      </div>
      <input
        {...input}
        type={showPassword ? 'text' : 'password'}
        value={newPassword}
        onChange={(e) => {
          input.onChange(e); // Update form state
          setNewPassword(e.target.value); // Also update password state
        }}
        placeholder="*************"
       className="bg-white pl-3 focus:outline-none h-9 w-full rounded-md text-base border border-[#3a5dd1] border-1  manrope-fontCss"
      />
      {meta.touched && meta.error && (
        <p className="text-red-500 text-sm text-left">&nbsp;{meta.error}</p>
      )}
      <div
        className="absolute h-15 top-11 -right-1 flex items-center px-4 cursor-pointer"
        onClick={togglePasswordVisibility}
      >
        {showPassword ? (
          <EyeNoneIcon className="h-5 w-5 text-black" />
        ) : (
          <EyeOpenIcon className="h-5 w-5 text-black" />
        )}
      </div>
    </div>
  )}
/>
              </div>

              <PasswordStrengthMeter password={newPassword} />

              <Button type="submit" onClick={onsubmit} className="w-full bg-[#0D215C] mt-4">
                Change Password
              </Button>
            </form>
          )}
        />
        {/* <button type='button' onClick={onClose} className="absolute top-2 right-2 text-gray-600">
          close
        </button> */}
      </div>
    </div>
  );
};

export default ResetPasswordDialog;
